import { useDispatch, useSelector } from "react-redux";
import InsufficientPermission from "../../custom/InSufficientPermission"
import Pagination from '@mui/material/Pagination'
import NoDataImg from '../../../assets/img/no-data.gif'
import { v4 as uuidv4 } from 'uuid'
import NavBar from "../../structure/NavBar"
import { Box, Switch } from "@mui/material"
import { NavBarTop } from "../../structure/NavBarTop"
import AddIcon from '@mui/icons-material/Add'
import { Button, Dropdown, Form, InputGroup } from "react-bootstrap"
import { useCallback, useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import Utils from "../../constants/Utils";
import { AddPackage } from "./AddPackage";
import { updateTopHeader, updateLoading } from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";
import Image from "../../custom/Image";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const PackageList = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [showAddPackage, setShowAddPackage] = useState(false);
    const [packageFormData, setPackageFormData] = useState({
        id: '',
        name: '',
        amount: 0,
        chips: 0,
        validityDays: 0,
        duration: 0,
        noExpiry: false,
        country: [],
        networkProviders: [],
        addOnOffer: false,
        dataBundle: 0,
        chipsBundle: 0
    })
    const { formatDate } = Utils();
    const [callAPi, setCallAPi] = useState('')
    const dispatch = useDispatch();
    const LOADING_ENABLE = useSelector((state) => state?.loading);
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    });
    const [sort_type, setSortType] = useState('createdAt');
    const [sort_order, setSortOrder] = useState(false);
    const [datalist, setDatalist] = useState([]);
    const [page, setPage] = useState(1);
    const userData = useSelector((state) => state?.userData);
    const [searchText, setSearchText] = useState('');
    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;

    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '30') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        editPermission = currentModulePermission.find((element) => {
            if (element.name === 'EDIT') {
                return element
            }
        }).isEnable
        deletePermissionVal = currentModulePermission.find((element) => {
            if (element.name === 'DELETE') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable

    }

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setPackageFormData(item)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditPackage = () => {
        console.log(packageFormData)
        setShowAddPackage(!showAddPackage)
        handleClose();
    }

    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }


    const handleAddPackage = () => {
        setShowAddPackage(!showAddPackage)
        setPackageFormData({
            id: '',
            name: '',
            amount: 0,
            chips: 0,
            validityDays: 0,
            duration: 0,
            noExpiry: false,
            country: [],
            networkProviders: [],
            addOnOffer: false,
            dataBundle: 0,
            chipsBundle: 0
        })
    };

    const handleSubmitPackage = async (url) => {
        try {
            dispatch(updateLoading(true))
            let postJson = {
                days: packageFormData?.validityDays,
                noExpiry: packageFormData?.noExpiry,
                name: packageFormData?.name,
                thumbnail: url,
                amount: packageFormData?.amount,
                chips: packageFormData?.chips,
                duration: packageFormData?.duration,
                id: packageFormData?.id,
                country: packageFormData?.country,
                networkProviders: packageFormData?.networkProviders,
                addOnOffer: packageFormData?.addOnOffer,
                dataBundle: packageFormData?.dataBundle,
                chipsBundle: packageFormData?.chipsBundle
            }
            let path = urls.addSubScriptionPackage
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
                setShowAddPackage(!showAddPackage)
                setCallAPi(uuidv4())
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }




    const handleStatusChange = async (event, id) => {
        // try {
        //   dispatch(updateLoading(true))
        //   let path = urls.changeCityStatus + '/' + id
        //   let res = await ApiCaller.put({}, path, userData?.access_token)
        //   const response = await res.response.json()
        //   if (response.status == 200) {
        //     dispatch(updateLoading(false))
        //     showToast(response?.message)
        //     getCityList("", startDate, endDate)
        //   } else {
        //     dispatch(updateLoading(false))
        //     showDangerToast(response.message)
        //   }
        // } catch (error) {
        //   dispatch(updateLoading(false))
        //   console.error(error)
        //   showDangerToast(error.message)
        // }
    };

    const handleEditCity = (item) => {
        // setShowAddState(true)
        // if (item?.countryId && item?.stateId) {
        //     getStateCodeListByCountryId(item?.countryId)
        // }
        // if (item?.stateId) {
        //     setCityFormData({
        //         ...item,
        //         isState: true,
        //         parentId: item?.stateId
        //     })
        // } else {
        //     setCityFormData({
        //         ...item,
        //         isState: false,
        //         parentId: item?.countryId
        //     })
        // }
    }

    const handleDeleteCity = (item) => {
        // Swal.fire({
        //   title: 'Are you sure?',
        //   text: 'You want to delete',
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: 'Yes!'
        // }).then(async result => {
        //   if (result.isConfirmed) {
        //     deleteApiCall(item?.id)
        //   }
        // })
    }

    const handleFilterClick = useCallback(() => {
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [searchText, startDate, endDate, statusDropdownText])

    const handleResetFilter = () => {
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText('Select Status')
        setSearchText('')
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    };


    useEffect(() => {
        dispatch(updateTopHeader('Subscription Package Manager'))
    }, [])


    useEffect(() => {
        if (viewPermission) {
            getSubscriptionPackageList()
        }
    }, [callAPi])

    const getSubscriptionPackageList = async () => {

        let startDateObject
        let endDateObject
        if (startDate?.toDate()) {
            let newDate = new Date(startDate?.toDate())
            // newDate.setDate(newDate.getDate() + 1)
            startDateObject = newDate
        }
        if (endDate?.toDate()) {
            let newDate = new Date(endDate?.toDate())
            // newDate.setDate(newDate.getDate() + 1)
            endDateObject = newDate
        }

        try {
            dispatch(updateLoading(true))
            let postJson = {
                searchText: searchText?.trim(),
                pageNumber: pagerecord?.pageNumber - 1 || 0,
                pageSize: pagerecord.pageSize || 10,
                shortingField: sort_type,
                asc: sort_order,
                active:
                    statusDropdownText === 'Active'
                        ? true
                        : statusDropdownText === 'In Active'
                            ? false
                            : null,
                startDate: startDateObject !== null ? startDateObject : '',
                endDate: endDateObject !== null ? endDateObject : ''
            }
            let path = urls.subscriptionPackageList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 10
                })
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    };



    return <>
        <NavBar />
        <div className='main-content'>
            <NavBarTop />
            <div className='header'>
                <div className='logo'>
                    <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                </div>
            </div>
            {
                viewPermission ? (
                    <>
                        <div className='container-fluid mt--7'>
                            <div className='row'>
                                <div className='col text-left'>
                                    <div className='card shadow'>
                                        <div className='card-header border-0'>
                                            <div className='row align-items-center text-left'>
                                                <div className='col'>
                                                    <h3 className='mb-0'>Subscription Package List</h3>
                                                </div>
                                                <div className='col text-right'>
                                                    {userData.admin ? (
                                                        <a
                                                            onClick={handleAddPackage}
                                                            className='btn btn-sm btn-primary text-white'
                                                        >
                                                            <AddIcon />
                                                            Add New
                                                        </a>
                                                    ) : editPermission ? (
                                                        <a
                                                            onClick={handleAddPackage}
                                                            className='btn btn-sm btn-primary text-white'
                                                        >
                                                            <AddIcon />
                                                            Add New
                                                        </a>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-header border-0'>
                                            <div className='row align-items-end text-left g-3' style={{ paddingBottom: '15px' }}>
                                                <div className='col-md-3'>
                                                    <div className="form-group mb-0">
                                                        <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                            <i className="fas fa-search mr-1"></i>Search Packages
                                                        </label>
                                                        <InputGroup>
                                                            <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
                                                                <i className="fas fa-search text-muted"></i>
                                                            </InputGroup.Text>
                                                            <Form.Control
                                                                placeholder='Search by name...'
                                                                value={searchText}
                                                                onChange={(e) => setSearchText(e.target.value)}
                                                                style={{ 
                                                                    fontSize: '14px',
                                                                    height: '38px',
                                                                    border: '1px solid #dee2e6'
                                                                }}
                                                            />
                                                        </InputGroup>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className="form-group mb-0">
                                                        <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                            <i className="fas fa-filter mr-1"></i>Status Filter
                                                        </label>
                                                        <Dropdown className="w-100">
                                                            <Dropdown.Toggle
                                                                variant='outline-secondary'
                                                                id='dropdown-basic'
                                                                className='w-100 text-left'
                                                                style={{
                                                                    height: '38px', 
                                                                    fontSize: '14px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    border: '1px solid #dee2e6',
                                                                    backgroundColor: '#fff'
                                                                }}
                                                            >
                                                                {statusDropdownText}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className="w-100">
                                                                <Dropdown.Item onClick={() => setStatusDropdownText('Select Status')}>
                                                                    Select Status
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => setStatusDropdownText('Active')}>
                                                                    Active
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => setStatusDropdownText('In Active')}>
                                                                    In Active
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-0">
                                                                <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                                    <i className="fas fa-calendar-alt mr-1"></i>From Date
                                                                </label>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        disableFuture
                                                                        value={startDate}
                                                                        onChange={(newValue) => setStartDate(newValue)}
                                                                        maxDate={endDate}
                                                                        slotProps={{ 
                                                                            textField: { 
                                                                                size: 'small',
                                                                                fullWidth: true,
                                                                                variant: 'outlined',
                                                                                placeholder: 'Select from date'
                                                                            } 
                                                                        }}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '38px',
                                                                                fontSize: '14px',
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #dee2e6',
                                                                                borderRadius: '0.375rem',
                                                                                '&:hover': {
                                                                                    borderColor: '#86b7fe'
                                                                                },
                                                                                '&.Mui-focused': {
                                                                                    borderColor: '#86b7fe',
                                                                                    boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.25)'
                                                                                }
                                                                            },
                                                                            '& .MuiInputLabel-root': {
                                                                                display: 'none'
                                                                            }
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group mb-0">
                                                                <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                                    <i className="fas fa-calendar-alt mr-1"></i>To Date
                                                                </label>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        disableFuture
                                                                        value={endDate}
                                                                        onChange={(newValue) => setEndDate(newValue)}
                                                                        minDate={startDate}
                                                                        slotProps={{ 
                                                                            textField: { 
                                                                                size: 'small',
                                                                                fullWidth: true,
                                                                                variant: 'outlined',
                                                                                placeholder: 'Select to date'
                                                                            } 
                                                                        }}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '38px',
                                                                                fontSize: '14px',
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #dee2e6',
                                                                                borderRadius: '0.375rem',
                                                                                '&:hover': {
                                                                                    borderColor: '#86b7fe'
                                                                                },
                                                                                '&.Mui-focused': {
                                                                                    borderColor: '#86b7fe',
                                                                                    boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.25)'
                                                                                }
                                                                            },
                                                                            '& .MuiInputLabel-root': {
                                                                                display: 'none'
                                                                            }
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            className='flex-grow-1'
                                                            onClick={handleFilterClick}
                                                            style={{
                                                                height: '38px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <i className="fas fa-search mr-2"></i>
                                                            Filter
                                                        </Button>
                                                        <Button
                                                            variant='outline-secondary'
                                                            className='flex-grow-1'
                                                            onClick={handleResetFilter}
                                                            style={{
                                                                height: '38px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <i className="fas fa-undo mr-2"></i>
                                                            Reset
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='table-responsive'>
                                            {datalist && datalist?.length > 0 ? (
                                                <>
                                                    <table className='table align-items-center table-flush'>
                                                        <thead className='thead-light'>
                                                            <tr>
                                                                <th scope='col'>S/No.</th>
                                                                <th scope='col'>Plan Title</th>
                                                                <th scope='col'>Amount</th>
                                                                <th scope='col'>Chips</th>
                                                                <th scope='col'>Duration</th>
                                                                <th scope='col'>Validity</th>
                                                                <th scope='col'>Thumbnail</th>
                                                                <th scope='col'>Created At</th>
                                                                <th scope='col'>Status</th>
                                                                {
                                                                    (editPermission || deletePermissionVal) &&
                                                                    <th scope='col' >Action</th>
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {datalist &&
                                                                datalist?.map((itemData, i) => {
                                                                    const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                                                    return (
                                                                        <>
                                                                            <tr key={i}>
                                                                                <td>{startIndex + i + 1}</td>
                                                                                <td>{itemData?.name}</td>
                                                                                <td>{itemData?.amount ? itemData?.amount : "-"}</td>
                                                                                <td>{itemData?.chips ? itemData?.chips : "-"}</td>
                                                                                <td>{itemData?.duration ? itemData?.duration : "-"}</td>
                                                                                <td>{itemData?.noExpiry ? 'No Expiry' : itemData?.validityDays}</td>
                                                                                <td>
                                                                                    <Image
                                                                                        image={{
                                                                                            id: 1,
                                                                                            src: itemData?.thumbnail
                                                                                        }}
                                                                                        width='80px'
                                                                                        height='auto
'
                                                                                    />
                                                                                </td>
                                                                                <td>{formatDate(itemData?.createdAt)}</td>
                                                                                <td>
                                                                                    {userData.admin ? (
                                                                                        <Switch
                                                                                            {...label}
                                                                                            checked={itemData?.active}
                                                                                            onChange={(e) =>
                                                                                                handleStatusChange(e, itemData?.id)
                                                                                            }
                                                                                            size='small'
                                                                                        />
                                                                                    ) : viewPermission ? (
                                                                                        <Switch
                                                                                            {...label}
                                                                                            checked={itemData?.active}
                                                                                            disabled={!activePermission}
                                                                                            onChange={(e) =>
                                                                                                handleStatusChange(e, itemData?.id)
                                                                                            }
                                                                                            size='small'
                                                                                        />
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                </td>
                                                                                <td className="text-right">
                                                                                    <IconButton size="small" onClick={(e) => handleClick(e, itemData)}>
                                                                                        <MoreVertIcon />
                                                                                    </IconButton>
                                                                                    <Menu
                                                                                        anchorEl={anchorEl}
                                                                                        open={open}
                                                                                        onClose={handleClose}
                                                                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                                                    >
                                                                                        {(userData.admin || editPermission) && (
                                                                                            <MenuItem
                                                                                                onClick={handleEditPackage}
                                                                                            >
                                                                                                Edit
                                                                                            </MenuItem>
                                                                                        )}
                                                                                    </Menu>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </>
                                            ) : (
                                                <>
                                                    <div className='text-center'>
                                                        <img width={'25%'} src={NoDataImg}></img>
                                                        <br />
                                                        <label style={{ fontWeight: 'bold' }}>
                                                            {LOADING_ENABLE ? (
                                                                <>Loading Data.....</>
                                                            ) : (
                                                                <>No Data Found</>
                                                            )}
                                                        </label>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        {datalist && datalist.length > 0 ? (
                                            <div className='card-footer py-4'>
                                                <Box display="flex" justifyContent="right" alignItems='center'>
                                                    <span>Total record: {pagerecord?.totalItems}</span>
                                                    <Pagination
                                                        className='custom-pagination-class'
                                                        count={pagerecord?.totalPages}
                                                        page={page}
                                                        onChange={handleChange}
                                                        color='secondary'
                                                    />
                                                </Box>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <AddPackage
                            show={showAddPackage}
                            packageFormData={packageFormData}
                            setPackageFormData={setPackageFormData}
                            onSubmit={(url) => handleSubmitPackage(url)}
                            onHide={() => setShowAddPackage(false)}
                        />
                    </>
                ) : (<InsufficientPermission />)
            }
        </div>
    </>
}